import { createSelector } from 'reselect'

const getBindersOnboarding = state => state.binders.onboarding

const binders_onboarding_selector = createSelector(
	[ getBindersOnboarding ],
	bindersOnboarding => ({
		step: bindersOnboarding.step,
	}))

export default binders_onboarding_selector
